import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AdvantagesBlockData from '../../../Models/Content/AdvantagesBlockData';
import Advantages from './Advantages';

export default class AdvantagesBlock extends EpiComponent<AdvantagesBlockData> {

    public render(): ReactNode | ReactNodeArray | null {
        return (
            <>
                <div className={'advantages'}>
                    <Advantages iContent={this.props.data} context={this.getContext()} />
                </div>
            </>
        );
    }
}
